import { Sessao } from './../shared/model/sessao/sessao.model';
import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { SessaoFiltro } from '../shared/model/sessao/sessao-filtro.model';
import { SessaoService } from '../shared/service/sessao.service';
import { MsgService } from './../shared/service/msg.service';
import { TituloRotinaComponent } from '../shared/components/app-titulo/titulo-component';
import { ButtonPadraoComponent } from '../shared/components/button-padrao/button-padrao.component';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import {FormBuilder, FormGroup, ReactiveFormsModule} from '@angular/forms';
import { debounceTime } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { ModalSessaoGlobalComponent } from './modal-sessao-global/modal-sessao-global.component';
import { ProgressBarDataComponent } from '../shared/components/progress-bar-data/progress-bar-data.component';
import { TabelaSkeletonComponent } from '../shared/components/tabela-skeleton/tabela-skeleton.component';
import {FormFieldComponent} from '../shared/components/form-field/form-field.component';
import {ModalConfirmacaoComponent} from '../shared/modais/modal-confirmacao/modal-confirmacao.component';
import {CelularMaskPipe} from '../shared/pipe/celular-mask.pipe';
import {AuthService} from '../shared/service/auth.service';
import {UsuarioLogado} from '../shared/model/usuario/usuario-logado.model';
import {ModalComponentChatComponent} from '../shared/modais/modal-component-chat/modal-component-chat.component';
import {RestricaoService} from '../shared/service/restricao.service';
import { CanalModel } from '../shared/model/canal/canal-model';
import {SessaoMobileComponent} from './mobile/sessao-mobile/sessao-mobile.component';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { PaginatorComponent } from '../shared/components/paginator/paginator.component';
@Component({
  selector: 'app-sessao',
  standalone: true,
  imports: [
    CommonModule,
    TituloRotinaComponent,
    MatTableModule,
    MatTooltipModule,
    ButtonPadraoComponent,
    ReactiveFormsModule,
    ProgressBarDataComponent,
    TabelaSkeletonComponent,
    FormFieldComponent,
    CelularMaskPipe,
    SessaoMobileComponent,
    MatPaginator,
    PaginatorComponent
  ],
  templateUrl: './sessao.component.html',
  styleUrl: './sessao.component.css'
})
export class SessaoComponent implements OnInit {
  readonly ROTINA_PARAMETRO_ID = 3;
  restricoes: string[] = [];

  private readonly destroyRef = inject(DestroyRef);
  private readonly sessaoService = inject(SessaoService);
  private readonly msgService = inject(MsgService);
  private readonly dialog = inject(MatDialog);
  private readonly authService = inject(AuthService);
  private readonly restricaoService = inject(RestricaoService);
  private readonly fb = inject(FormBuilder);

  sessoes: Sessao[] = [];
  sessoesDataSource = new MatTableDataSource<Sessao>();
  trackById = (_: number, item: Sessao) => item.id;
  filtro: SessaoFiltro = new SessaoFiltro();
  carregandoDadosTabela = true;
  dadosSkeleton: Sessao[] = [];
  usuarioLogado: UsuarioLogado = new UsuarioLogado();

  formSessao: FormGroup;
  isPrimeiraAberturaFiltros = true;

  larguraTela?: number;

  page = 0;
  limit = 20;
  length = 0;

  displayedColumns: string[] = [
    'acao',
    'id',
    'tempoParaFinalizar',
    'tempoEtapaAtual',
    'etapaFluxoAtual',
    'canal',
    'operador',
    'numeroContato',
    'nomeContato',
    'remetente',
    'ativo',
    'dataInicio',
    'dataUltimaMensagem'
  ];

  constructor() {
    this.formSessao = this.fb.group({
      numNome: ['']
    });
  }

  ngOnInit() {
    this.buscarLarguraTela();
    this.usuarioLogado = this.authService.getUsuarioLogadoClariBot();
    this.buscarRestricoes();
    this.dadosSkeleton = Array.from({ length: 5 }, () => new Sessao());
    this.sessoesDataSource = new MatTableDataSource(this.dadosSkeleton);
    this.iniciarFiltros(true);
    this.configurarDebounce();
  }

  buscarLarguraTela(){
    this.larguraTela = window.innerWidth;
  }

  buscarRestricoes() {
    this.restricaoService.buscarRestricoesPorRotina(this.ROTINA_PARAMETRO_ID).subscribe({
      next: res => this.restricoes = res.filter(r => r.permite).map(re => re.chave ?? '')
    });
  }

  configurarDebounce(): void {
    this.formSessao.get('numNome')!.valueChanges.pipe(
      debounceTime(300),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(value => this.filtrarPorNome(value));
  }

  iniciarFiltros(buscarSessoes: boolean) {
    this.filtro = new SessaoFiltro();
    this.filtro.nomeContato = '';
    this.filtro.atividade = { id: 1, nome: 'Ativo' };
    this.filtro.fluxos = [];
    this.filtro.operadores = [];
    this.isPrimeiraAberturaFiltros = true;
    if (buscarSessoes) { this.buscarSessoes(); }
  }

  buscarSessoes() {
    this.carregandoDadosTabela = true;
    this.sessaoService.buscarSessoesComFiltro(this.filtro, this.page, this.limit).subscribe({
      next: res => {
        this.sessoes = res.content;
        this.sessoesDataSource = new MatTableDataSource(this.sessoes);
        this.length = res.totalElements;
      },
      complete: () => this.carregandoDadosTabela = false
    });
  }

  filtrarPorNome(nome: string): void {
    this.filtro.nomeContato = nome;
    this.buscarSessoes();
  }

  inativarSessao(elemento: Sessao){
    this.dialog.open(ModalConfirmacaoComponent, {
      data: {
        texto: 'Deseja inativar sessão?',
      }
    }).afterClosed().subscribe({
      next: (res: boolean) => {
        if (res) {
          this.sessaoService.inativarSessao(elemento.id!).subscribe({
            next: () => {
              this.msgService.msgSucesso('Sessão inativada com sucesso.');
              this.buscarSessoes();
            },
            error: () => this.msgService.msgErro('Erro ao inativar sessão.')
          });
        }
      }
    });
  }

  reiniciarSessao(elemento: Sessao){
    this.dialog.open(ModalConfirmacaoComponent, {
      data: {
        texto: 'Deseja reiniciar a sessão?',
      }
    }).afterClosed().subscribe({
      next: (res: boolean) => {
        if (res) {
          this.sessaoService.reiniciarSessao(elemento.id!).subscribe({
            next: res => {
              if(res){
                this.buscarSessoes();
                this.msgService.msgSucesso('Sessão reiniciada com sucesso.');
              }
              else{
                this.msgService.msgAdvertencia('Não possui Paramêtro de Reinicio de Sessão Configurada.');
              }
            }
          });
        }
      }
    });
  }

  abrirModalFiltro() {
    this.dialog.open(ModalSessaoGlobalComponent, {
      width: '361px', height: '100vh',
      position: {
        top: '0',
        right: '0'
      },
      data: {
        isFiltro: true,
        filtros: this.filtro,
        isPrimeiraAberturaFiltros: this.isPrimeiraAberturaFiltros
      },
      panelClass: 'slide-modal'
    }).afterClosed().subscribe((resultado: SessaoFiltro | null) => {
      if (resultado) {
        this.filtro = resultado;
        this.buscarSessoes();
        this.isPrimeiraAberturaFiltros = false
      }
    });
  }

  abrirModalDetalhes(sessao?: Sessao, isVisualizacao?: boolean) {
    const sessaoObj = JSON.parse(JSON.stringify(sessao ? sessao : new Sessao())) as Sessao;
    this.dialog.open(ModalSessaoGlobalComponent, {
      width: '361px', height: '100vh',
      position: {
        top: '0',
        right: '0'
      },
      data: {
        isVisualizacao: isVisualizacao,
        isFiltro: false,
        sessao: sessaoObj
      },
      panelClass: 'slide-modal'
    }).afterClosed().subscribe((resultado: Sessao | null) => {
      if (resultado) {
        if(sessao?.ativo === resultado.ativo){
          if (sessao) {
            resultado.tempoFinalizar = sessao.tempoFinalizar;
            resultado.dataFormatadaFinalizar = sessao.dataFormatadaFinalizar;
            resultado.tempoEtapaAtual = sessao.tempoEtapaAtual;
            resultado.dataInicio = sessao.dataInicio;
            resultado.dataUltimaMensagem = sessao.dataUltimaMensagem;
          }
          this.sessaoService.alterarSessao(resultado).subscribe({
            next: () => this.msgService.msgSucesso('Sessão atualizada com sucesso.'),
            complete: () => this.buscarSessoes()
          });
        } else {
          this.inativarSessao(resultado);
        }
      }
    });
  }

  abrirModalChat(sessao?: Sessao) {
    const contato = sessao?.contato;
    if (contato) {
      contato.canal = sessao?.canal as CanalModel;
      contato.temSessaoAberta = sessao?.ativo;
      this.dialog.open(ModalComponentChatComponent, {
        width: '80vw', height: '100vh',
        position: {
          top: '0',
          right: '0'
        },
        data: { contato },
        panelClass: 'slide-modal'
      });
    }
  }

  handlePageEvent(e: PageEvent) {
    this.page = e.pageIndex;
    this.limit = e.pageSize;
    this.buscarSessoes();

  }
}
